export function useMath() {
  const roundToPlaces = (value: number, places: number): number => {
    const multiplier = Math.pow(10, places)
    return Math.round(value * multiplier) / multiplier
  }

  const roundToFixed = (value: number, places: number): string => {
    const multiplier = Math.pow(10, places)
    return (Math.round(value * multiplier) / multiplier).toFixed(places)
  }

  // A zero average has no meaningful relative difference; return 0 rather than NaN/Infinity.
  const relativePercentDifference = (x1: number, x2: number): number => {
    const average = (x1 + x2) / 2
    if (average === 0) return 0
    return Math.abs(x1 - x2) / average
  }

  // Capped because zero and negative values never reach 1 and would loop forever.
  const MAX_FRACTION_PLACES = 10

  const requiredFractionPlaces = (value: number): number => {
    let count = 0
    while (value < 1 && count < MAX_FRACTION_PLACES) {
      count++
      value *= 10
    }
    return count
  }

  return { roundToPlaces, roundToFixed, relativePercentDifference, requiredFractionPlaces }
}
